import React from 'react';
import PropTypes from 'prop-types';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import RadioWithTracking from '@Pages/ProfileSettings/Preferences/components/RadioWithTracking';

function SalutationSection({ name, label, value, onChange, onSave, onClose, title, options }) {
  return (
    <ProfileSettingsAccordionItem onClose={onClose} label={label} value={value} onSave={onSave} formValid title={title}>
      {options &&
        options.map((option) => {
          const id = `${name}-${option.id}`;
          return (
            <div key={id} className="search-drawing1 clearfix">
              <RadioWithTracking
                id={id}
                currentValue={value}
                name={id}
                label={option.salutation}
                value={option.id}
                onChange={onChange}
                aria-label={`${title}: ${option.salutation}`}
              />
            </div>
          );
        })}
    </ProfileSettingsAccordionItem>
  );
}

SalutationSection.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, salutation: PropTypes.string })),
};

export default SalutationSection;
